module.exports = __webpack_public_path__ + "static/mockup-schedule-3-75b5c45fc97b9ed95bb2e006079ce3f2.png";